/** Pure geometry for the hand-drawn SVG charts (no chart library, spec §8). */
export function niceMax(v: number): number {
  if (!(v > 0)) return 1
  const exp = Math.pow(10, Math.floor(Math.log10(v)))
  for (const m of [1, 2, 5, 10]) if (m * exp >= v) return m * exp
  return 10 * exp
}

export function linePoints(values: number[], width: number, height: number, max?: number): string {
  if (values.length === 0) return ''
  const top = max ?? niceMax(Math.max(...values))
  const pad = 2
  const x = (i: number) => (values.length === 1 ? width / 2 : (i * width) / (values.length - 1))
  const y = (v: number) => height - (Math.min(v, top) / top) * (height - pad)
  return values.map((v, i) => `${Math.round(x(i))},${Math.round(y(v))}`).join(' ')
}

export function pct(part: number, whole: number): number {
  return whole > 0 ? Math.round((part / whole) * 1000) / 10 : 0
}

export function ticks(max: number, n = 3): number[] {
  return Array.from({ length: n }, (_, i) => Math.round((max * i) / (n - 1)))
}
